export const formats = {
  standard: {
    jalaliDate: "jYYYY-jMM-jDD",
    jalaliDateTime: "jYYYY-jMM-jDDTHH:mm:ss.SSSZ",
    utcDate: "YYYY-MM-DD",
    utcDateTime: "YYYY-MM-DDTHH:mm:ss.SSSZ",
  },
  ui: {
    jalaliDate: "jYYYY/jMM/jDD",
    jalaliDateTime: "jYYYY/jMM/jDD HH:mm",
    time: "HH:mm",
    utcDate: "YYYY/MM/DD",
    utcDateTime: "YYYY/MM/DD HH:mm",
  },
} as const;
